"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgLink(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M16.216 12.518l-3.195-3.195S9.7 6.176 6.195 9.759c-3.503 3.582-.436 6.826-.436 6.826l9.585 9.585s3.461 2.836 6.827-.436c3.365-3.27.436-6.826.436-6.826l-1.598-1.597", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M24.63 28.275l3.195 3.195s3.41 3.16 6.826-.437c3.415-3.597.436-6.825.436-6.825l-9.584-9.584s-3.249-3-6.825.436c-3.577 3.437-.437 6.826-.437 6.826l1.598 1.597", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
}
exports.default = SvgLink;
//# sourceMappingURL=Link.js.map